import { useEventListener } from '@mantine/hooks';

export function useMouseTracker(): React.RefCallback<HTMLDivElement | null> {
  return useEventListener('mousemove', handleMouseMove);
}

function handleMouseMove(this: HTMLDivElement, e: MouseEvent) {
  const rect = this.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  const percentX = (x / rect.width) * 100;
  const percentY = (y / rect.height) * 100;

  const centerX = rect.width / 2;
  const centerY = rect.height / 2;
  const deltaX = x - centerX;
  const deltaY = y - centerY;
  let angleDeg = Math.atan2(deltaY, deltaX) * (180 / Math.PI) + 90;

  if (angleDeg < 0) {
    angleDeg += 360;
  }

  this.style.setProperty('--mouse-x', `${percentX}%`);
  this.style.setProperty('--mouse-y', `${percentY}%`);
  this.style.setProperty('--angle', `${angleDeg}deg`);
}
